export default class PreincidenciaToIncidencia{
	constructor(){
		this.preincidencia;
	}

	setPreincidencia(data){
		this.preincidencia = data;
	}

	getPreincidencia(){
		return this.preincidencia;
		this.preincidencia = undefined;
	}

	clear(){
		this.preincidencia = undefined;
	}
}



// WEBPACK FOOTER //
// ./app/js/services/preincidenciaToIncidencia.js